export const getToken = () => {
    return localStorage.getItem('AccessToken') || '';
};

export const setToken = (token) => {
    localStorage.setItem('AccessToken', token);
};
